/* eslint-disable array-callback-return */
import React, { useContext } from 'react'
import { PRODUCTS } from '../../products'
import Product from '../shop/Product'
import { ShopContext } from '../../context/ShopContextProvider'
import CartItem from './CartItem'
import { useNavigate } from 'react-router-dom'
import './cart.css'

const Cart = () => {
  const {cartItems, getTotalCartAmount} = useContext(ShopContext)
  const totalAmount = getTotalCartAmount()
  const navigate = useNavigate()
  return (
    <div className='cart'>
      <div>
        <h1>your cart items</h1>
      </div>
      <div className='cartItems'>
        {PRODUCTS.map((Product)=>{
          if(cartItems[Product.id] !== 0){
            return <CartItem data={Product} />
          }
        })}
      </div>
      {totalAmount > 0 ?(
      <div className='checkout'>
        <p>Total Amount: ${totalAmount} </p>
        <button onClick={()=>navigate('/')}>Continue Shopping!</button>
        <button>Checkout</button>
      </div>
  ):( 
      <><h1>Your Cart is Empty!</h1>
      <button className='go-back' onClick={() => navigate('/')}>go back to shop?</button></>   
    )}
    </div>
  )
}

export default Cart
